import React from "react";
import Header from '../home/header/header';
import Footer from '../home/footer/footer';
import AboutUs from './about-us/about-us';
import "./about.css";
import Ourstory from './our-story/our-story';
import Ourteam from './our-team/our-team';
import {headerType} from '../home/home'

const About = ( {signedIn, handleLogOut} ) => {
  return (
    <>
    <Header signedIn={signedIn} handleLogOut={handleLogOut} param={headerType.ABOUT}/>
    <AboutUs/>
    <Ourstory/>
    <Ourteam/>
    <Footer/>
    </>
  );
}

export default About;
